import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CacheService } from 'src/app/core/services/cache/cache.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { ToastService } from 'src/app/core/services/toast/toast.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { PARAM_LABEL_INTERVENTION } from 'src/app/core/services/constant/constants.service';

@Component({
	selector: 'app-mission-place-modal-ajout-form',
	templateUrl: './mission-place-modal-ajout-form.component.html',
	styleUrls: ['./mission-place-modal-ajout-form.component.scss']
})
export class MissionPlaceModalAjoutFormComponent implements OnInit {
	MAX_NAME_CHAR = 50;
	NAME_PATTERN = new RegExp(
		"^[0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+( [0-9a-zA-z'éèàç.ÆæÇÉÈŒœÙ',_-]+)*$"
	);

	isAddressSelected: { value: boolean } = { value: false };
	isAddressDefault: { value: boolean } = { value: true };

	formAjout = new FormGroup({
		address: new FormControl('', Validators.required),
		name: new FormControl('', [
			Validators.required,
			Validators.maxLength(this.MAX_NAME_CHAR),
			Validators.pattern(this.NAME_PATTERN)
		]),
		notes: new FormControl('', Validators.maxLength(1023))
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = { value: false };

	labelIntervention: string;

	missionPlace: MissionPlace = new MissionPlace();

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService,
		private cache: CacheService,
		private toastService: ToastService
	) {}

	ngOnInit(): void {
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
	}

	onSubmit() {
		if (
			this.formAjout.valid &&
			(this.isAddressDefault.value || this.isAddressSelected.value)
		) {
			this.isValidateButtonClicked.value = true;
			this.facade.missionPlaceService
				.addMissionPlace(this.missionPlace)
				.subscribe({
					complete: () => {
						this.isValidateButtonClicked.value = false;
						this.bsModalRef.hide();
					},
					error: (err: ErrorResponse) => {
						this.isValidateButtonClicked.value = false;
						this.facade.toastService.createHttpErrorToast(
							err.error.response,
							err.status
						);
					}
				});
		}
	}
}
